<p-card styleClass="app-frame">
  <h1>
    <section-title [contentKey]="'acc_regHome_label_register'" [admin]="adminMode"></section-title>
  </h1>
  <div class="disclaimerSection" tabindex="0">
    <section-instructions [contentKey]="'acc_disclaimer_label_disclaimer'" [admin]="adminMode"></section-instructions>
    <section-instructions [contentKey]="'acc_disclaimer_label_disclaimer1'" [admin]="adminMode"></section-instructions>
    <section-instructions [contentKey]="'acc_disclaimer_label_disclaimer2'" [admin]="adminMode"></section-instructions>
    <section-instructions [contentKey]="'acc_disclaimer_label_disclaimer3'" [admin]="adminMode"></section-instructions>
  </div>
</p-card>
